/* istanbul ignore file */
export enum AliasesDefaultValues {
    SingularProject = 'Project',
    PluralProject = 'Projects',
    SingularSite = 'Site',
    PluralSite = 'Sites',
}
